export class WebGLConfig {
}
